import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

const CONTENT = {
  realtor: {
    tag: "For Realtors",
    title: "This is a total game changer",
    lead:
      "Tired of chasing down your lender for an exact pre-approval or loan summary so your buyers walk into an offer with confidence?",
    paras: [
      "Enter My Pocket Lender — instant pre-approvals up to the designated max purchase price your lender sets, at your fingertips.",
      "Your lender uploads your client's loan estimate once; from there you send pre-approvals yourself (your lender handles the loan estimates). No more running around — you get back to getting families into homes.",
    ],
    close: "Welcome to the modern way of doing business in real estate.",
    cta: { label: "Request agent access", to: "/signup" },
  },
  lender: {
    tag: "For Lenders",
    title: "Win back your nights & weekends",
    lead:
      "Tired of last-minute, after-5PM and weekend pre-approval requests that pull you out of working ON your business and into working IN it?",
    paras: [
      "Say hello to My Pocket Lender. Your realtors send approvals with loan summaries instantly — while you stay in the loop — all based on what the buyer actually qualifies for.",
      "You upload the loan estimate once and we build the pre-approval and loan summary from it 100%, so terms always match. The realtor just updates the offer price, taxes and HOA.",
    ],
    close: "Welcome to the modern way of doing business in real estate & mortgage lending.",
    cta: { label: "Request access", to: "/signup" },
  },
};

const SHARED = [
  "Customized pre-approvals & loan estimates, elegantly designed.",
  "You set the offer price, taxes and HOA — we do the rest.",
  "Automatic 30-day check-in updates, CC'd to lender and realtor.",
];

export default function RoleInfoModal({ role, onClose }) {
  const c = role ? CONTENT[role] : null;
  return (
    <Dialog open={!!role} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-md bg-[#0d0d0d] border border-[#ff3b30]/25 text-white p-0 overflow-hidden max-h-[92vh]"
        data-testid={`role-info-modal-${role || ""}`}
      >
        {c && (
          <div className="px-6 pt-6 pb-5">
            <DialogTitle className="sr-only">{c.title}</DialogTitle>
            <DialogDescription className="sr-only">{c.lead}</DialogDescription>
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#ff6a61] font-bold">{c.tag}</div>
            <h2 className="font-display text-2xl tracking-tight mt-1.5 leading-tight">{c.title}</h2>

            <p className="text-white/85 text-sm leading-snug font-medium mt-3">{c.lead}</p>
            {c.paras.map((p, i) => (
              <p key={i} className="text-white/55 text-[13px] leading-snug mt-2">
                {p}
              </p>
            ))}

            <div className="mt-3.5 space-y-2">
              {SHARED.map((s, i) => (
                <div key={i} className="flex items-start gap-2.5">
                  <span className="mt-0.5 shrink-0 h-4 w-4 rounded-full bg-[#ff3b30]/15 text-[#ff3b30] flex items-center justify-center">
                    <Check className="h-2.5 w-2.5" />
                  </span>
                  <p className="text-[13px] text-white/75 leading-snug">{s}</p>
                </div>
              ))}
            </div>

            <p className="mt-4 font-display text-base text-white/90 leading-snug">{c.close}</p>

            <div className="mt-4 flex gap-3">
              {c.cta && (
                <Button
                  asChild
                  className="flex-1 h-11 bg-[#ff3b30] hover:bg-[#ff5147] text-white font-semibold rounded-xl"
                >
                  <Link to={c.cta.to} data-testid="role-info-cta" onClick={onClose}>
                    {c.cta.label}
                  </Link>
                </Button>
              )}
              <Button
                onClick={onClose}
                variant="outline"
                data-testid="role-info-dismiss"
                className="flex-1 h-11 rounded-xl border-white/15 bg-white/5 text-white hover:bg-white/10"
              >
                Got it
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
